import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CreateInvoiceDialogContentComponent } from './create-invoice-dialog-content/create-invoice-dialog-content.component';

@Component({
  selector: 'app-create-invoice-dialog',
  template: ''
})
export class CreateInvoiceDialogComponent implements OnInit {

  constructor(
    public dialog: NgbModal,
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) { }

  ngOnInit() {
    this.openDialog();
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(CreateInvoiceDialogContentComponent, { centered: true, backdrop: 'static', size: 'xl' });
    dialogRef.componentInstance.userId = this.activatedRoute.snapshot.params.key;
    dialogRef.componentInstance.customerId = this.activatedRoute.parent.parent.snapshot.params.key;

    dialogRef.result.then((result) => {
      this.router.navigate(['../../'], { relativeTo: this.activatedRoute });
    }, (backdrop) => {
      this.router.navigate(['../../'], { relativeTo: this.activatedRoute });
    });
  }
}
